import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { openAddressModal } from "actions/ui";
import { extractCustomerFromState } from "helpers";
import { modifyCustomer, getCustomerAddress } from "actions/customer";
import cx from "classnames";

const mapStateToProps = (state, ownProps) => {
    const customer = extractCustomerFromState(state, ownProps.customerId);
    return {
        primaryAddress: customer && customer.primaryAddress,
    };
};

const mapDispatchToProps = { openAddressModal, modifyCustomer, getCustomerAddress };

// this field is only used for left customer panel
const AddressField = props => {
    const {
        label,
        disabled,
        savedValue,
        customClassName,
        customerId,
        customerType,
        openAddressModal,
        primaryAddress,
        modifyCustomer,
        getCustomerAddress,
    } = props;

    const handleOpenAddressModal = () => {
        if (!disabled) {
            openAddressModal({
                address: primaryAddress,
                customerId: customerId,
                customerObjectType: "CUSTOMER",
                staticBlockFormKey: `left_panel_customer_${customerType.toLowerCase()}_form_new`,
                onAddressSave: () => {
                    modifyCustomer(customerId);
                    getCustomerAddress({ customerId }, customerId);
                },
                withoutAddressType: true,
                defaultType: "physical",
            });
            // openAddressModal();
        }
    };

    return (
        <div className={cx("field-controller", { disabled })}>
            <div className="input-element">
                <div className="input-label">{label}</div>
                <div className="input-field-wrap" onClick={handleOpenAddressModal}>
                    <div
                        className={cx("input-field", {
                            disabled,
                            textarea: savedValue,
                            [customClassName]: customClassName,
                        })}
                        title={savedValue}
                    >
                        {savedValue}
                    </div>
                </div>
            </div>
        </div>
    );
};

AddressField.propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    savedValue: PropTypes.string,
    customClassName: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressField);
